import { render, staticRenderFns } from "./TaskProps.vue?vue&type=template&id=45e52b48&scoped=true"
import script from "./TaskProps.vue?vue&type=script&lang=js"
export * from "./TaskProps.vue?vue&type=script&lang=js"
import style0 from "./TaskProps.vue?vue&type=style&index=0&id=45e52b48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e52b48",
  null
  
)

export default component.exports